export default "__VITE_ASSET__rTCMMJwo__"